import { Icon } from '@iconify/react';
import React from 'react';
import { Link } from 'react-router-dom';

const Social = () => {
  return (
    <ul className="st-social-btn st-style1 st-mp0">
      <li>
        <Link to='https://www.instagram.com/rosa_coppola_dott.ssa_salerno/' target='_blank'>
          <Icon icon="fa6-brands:square-instagram" />
        </Link>
      </li>
      <li>
        <Link to='https://www.facebook.com/rosacoppola2021' target='_blank'>
          <Icon icon="fa6-brands:square-facebook" />
        </Link>
      </li>
    </ul>
  )
}

export default Social;
